export default function (subFlows, branchOnProductCodeFn) {
    // this function will get passed step,junction and flow parameters but we here we are not creating any new steps
    // or junctions just to wiring up entry and exits so they are not needed.
    return () => {
        const lobSubFlows = {
            bop: subFlows.bopFlows,
            cp: subFlows.cpFlows,
            ho: subFlows.hoFlows,
            pa: subFlows.paFlows,
            puw: subFlows.puwFlows,
            wc7: subFlows.wc7Flows
        };

        subFlows.submissionExists.exits.submissionCreationChecked
            .onNext.branch(branchOnProductCodeFn(lobSubFlows, 'coverables')); // PSA
            // PSA .onNext.branch(branchOnProductCodeFn(lobSubFlows, 'contactDetails'));

        // PSA
        // if (subFlows.paFlows) {
        //     subFlows.paFlows.contactDetails.exits.paContactDetailsComplete.onNext.goTo(subFlows.needToSaveCheck.entry);
        //     subFlows.paFlows.coverables.exits.paCoverablesComplete.onNext.goTo(subFlows.quote.entry);
        //     subFlows.paFlows.moreInfo.exits.paMoreInfoComplete.onNext.goTo(subFlows.bind.entry);
        // }

        if (subFlows.puwFlows) {
            subFlows.puwFlows.coverables.exits.puwCoverablesComplete.onNext.goTo(subFlows.puwFlows.quote.entry);
            subFlows.puwFlows.quote.exits.offeringSelected.onNext.goTo(subFlows.puwFlows.bindAndPay.entry);
        }

        if (subFlows.hoFlows) {
            subFlows.hoFlows.contactDetails.exits.hoContactDetailsComplete.onNext.goTo(subFlows.needToSaveCheck.entry);
            subFlows.hoFlows.coverables.exits.hoCoverablesComplete.onNext.goTo(subFlows.quote.entry);
            subFlows.hoFlows.moreInfo.exits.hoMoreInfoComplete.onNext.goTo(subFlows.bind.entry);
        }

        if (subFlows.cpFlows) {
            subFlows.cpFlows.contactDetails.exits.cpContactDetailsComplete.onNext.goTo(subFlows.needToSaveCheck.entry);
            subFlows.cpFlows.coverables.exits.cpCoverablesComplete.onNext.goTo(subFlows.quote.entry);
            subFlows.cpFlows.moreInfo.exits.cpMoreInfoComplete.onNext.goTo(subFlows.bind.entry);
        }

        if (subFlows.bopFlows) {
            subFlows.bopFlows.contactDetails.exits.bopContactDetailsComplete.onNext.goTo(subFlows.needToSaveCheck.entry);
            subFlows.bopFlows.coverables.exits.bopCoverablesComplete.onNext.goTo(subFlows.quote.entry);
            subFlows.bopFlows.moreInfo.exits.bopMoreInfoComplete.onNext.goTo(subFlows.bind.entry);
        }

        if (subFlows.wc7Flows) {
            subFlows.wc7Flows.contactDetails.exits.wc7PolicyDetailsAndQualificationComplete.onNext.goTo(subFlows.needToSaveCheck.entry);
            subFlows.wc7Flows.coverables.exits.wc7CoverablesComplete.onNext.goTo(subFlows.wc7Flows.quote.entry);
            subFlows.wc7Flows.moreInfo.exits.wc7MoreInfoComplete.onNext.goTo(subFlows.bind.entry);
        }
        // PSA
        // subFlows.quote.exits.offeringSelected
        //     .onNext.branch(branchOnProductCodeFn(lobSubFlows, 'moreInfo'));

        subFlows.needToSaveCheck.exits.needToSaveCheckSuccess
            .onNext.branch(branchOnProductCodeFn(lobSubFlows, 'coverables'));
    };
}